import { useMutation } from '@apollo/client'
import { useAppDispatch } from '_store'
import { EledoPageHeader } from 'components/library'
import { AuthenticateDataData, AuthenticateVars, GET_AUTHENTICATE } from 'graphql/AuthQueries'
import React, { useContext, useState } from 'react'
import classnames from "classnames";
import styles from 'components/library/EledoPageHeader.module.scss';
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from 'AuthContext'
import { setAllRequests } from '_reducers/puzzleRequests'
import { EledoAccount } from 'graphql/EledoAccountQueries'

type LocationState = {
  userId: string
  accounts: [EledoAccount]
  type: string
  payload: string
  rememberMe: boolean
  email: string
  from: {
    pathname: string
    search: string
  }
}

const EledoLoginAccountSelect = () => {

  const auth = useContext(AuthContext);
  const navigate = useNavigate()
  const state = useLocation().state as LocationState;
  const [rememberMe, setRememberMe] = useState(state.rememberMe)

  const dispatch = useAppDispatch();
    const [doAuth, { error }] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
      onCompleted(data, clientOptions) {
        if(data){
          
          // console.log(data)
          
          if(data){
            const authVars = clientOptions?.variables as AuthenticateVars
            
            auth.login(data.authenticate, authVars.type);
            
            if(data.authenticate.requests){
              dispatch(setAllRequests(data.authenticate.requests));
            }
  // console.log(state.from)
            if(data.authenticate.user !== null){
              if(state?.from?.pathname){
                navigate(state.from.pathname + state.from.search);
              }else{
                navigate("/templates/mine");
              }
            }
          }
        }
      },
      onError(error){
      }
    });

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            <h1>Select account</h1>
          </div>
              <div className="col-50 center text-center">
                
                { error === undefined && state.accounts && state.accounts.map(account => (
                  <div key={account.id}>
                    <button className={"button w-button"} style={{width: '100%'}} key={account.id} onClick={() => {
                      doAuth({ variables: {
                        userId: state.userId,
                        accountId: account.id,
                        type: state.type,
                        payload: state.payload,
                        rememberMe: rememberMe
                      }})
                    }}>{account.name}</button>
                  </div>
                ))}

                {error !== undefined && 
                  <>
                    <p>Failed: {error.message}</p>
                    <button className={"button"} type="submit" onClick={() => navigate('/login/start')}>
                      Start Over
                    </button>
                  </>}

                {/* <input type="checkbox" checked={rememberMe} onClick={() => {setRememberMe(!rememberMe)}}></input> */}


              </div>
        </div>
      </div>
    </div>
  )
}


export default EledoLoginAccountSelect